import React, { useMemo } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import { DesignCanvasLayer } from 'models/cms/booths';
import { selectLocale } from 'models/localization';
import findAvailableLocale from 'models/helpers/findAvailableLocale';
import StyledContainer from '../styled';

const StyledSVG = styled.svg`
  width: 100%;
  height: 100%;
`;

interface ElementProps {
  layer: DesignCanvasLayer;
  onElementClick: () => void;
}
const Element: React.FC<ElementProps> = ({
  layer,
  onElementClick,
}: ElementProps) => {
  const locale = useSelector(selectLocale);
  const imageUrl: string = useMemo(() => findAvailableLocale(layer?.maskImage, locale)?.originalImageUrl, [layer?.maskImage, locale]);
  const fillColor: string = useMemo(() => layer?.fillColor, [layer?.fillColor]);
  const colorMaskId = useMemo(() => uuidv4(), []);

  const {
    positionX, positionY, height, width,
  } = layer;

  return !!imageUrl && (
    <StyledContainer width={width} height={height} positionX={positionX} positionY={positionY} onClick={onElementClick}>
      <StyledSVG>
        <defs>
          <filter id={colorMaskId}>
            <feFlood floodColor={fillColor} result="flood" />
            <feComposite in="SourceGraphic" in2="flood" operator="arithmetic" k2="1" k3="1" result="colored" />
            <feComposite in="colored" in2="SourceGraphic" operator="in" />
          </filter>
        </defs>
        <image
          width="100%"
          height="100%"
          preserveAspectRatio="none"
          href={imageUrl}
          filter={`url(#${colorMaskId})`}
        />
      </StyledSVG>
    </StyledContainer>
  );
};

export default Element;
